'use client'

import { useFieldValue, useForm } from 'form-atoms'
import { useCallback } from 'react'
import { TokenSelector } from '@/src/components/form/token-selector'
import { swapFormAtom } from '@/src/stores/swap/atoms'
import { useTokenSelection } from '@/src/stores/token-selection/actions'
import { FromAmountInput } from './from-amount-input'

export const FromSection = () => {
  const { fieldAtoms } = useForm(swapFormAtom)
  const fromTokenValue = useFieldValue(fieldAtoms.from)
  const { open: openTokenSelection } = useTokenSelection()

  /**
   * If from token value is not set we would like to open token selection,
   * if they press amount input or other place inside from section
   */
  const onClick = useCallback(() => {
    if (fromTokenValue?.chain) return

    openTokenSelection('from')
  }, [fromTokenValue, openTokenSelection])

  return (
    <div
      className='flex items-center gap-2 py-4 px-3 justify-between'
      onMouseDown={onClick}
    >
      <FromAmountInput />
      <TokenSelector direction='from' />
    </div>
  )
}
